import { LossePlaatjie } from '@ubo/losse-sjedel'
import Animated from '~/components/elements/Animated'
import Content from '~/components/elements/Content'
import Links from '~/components/elements/Links'
import type { Page_Flexcontent_Flex_Content } from '~/graphql/types'

export default function ContentCtaCustom({ fields }: { fields: Page_Flexcontent_Flex_Content }) {
  return (
    <section data-component="ContentCtaCustom" className="section">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-8 gap-x-10 lg:gap-x-24">
          <div className="flex justify-center lg:justify-end">
            <div className="relative max-w-[478px] max-h-[352px]">
              <Animated delay={100}>
                <div className="bg-black pb-7">
                  <LossePlaatjie
                    className="sm:min-w-[478px] w-full sm:w-[478px] h-[250px] sm:h-[324px] object-cover"
                    maxwidth={1000}
                    src={fields.image}
                  />
                </div>
              </Animated>

              <Animated delay={300}>
                <div className="absolute bottom-0 left-0 pb-4 w-full">
                  <div className="absolute w-full h-[140px] left-0 bottom-0 bg-gradient-to-t from-black via-black to-transparent" />
                  <span className="block relative z-20 mb-1 px-2 text-white font-bold text-center text-lg sm:text-2xl">
                    {fields.subtitle}
                  </span>
                  <span className="block relative z-20 text-site-accent text-center">{fields.extratitle}</span>
                </div>
              </Animated>
            </div>
          </div>
          <div className="flex flex-col justify-center">
            <h2 className="title--medium max-lg:text-center mb-3 lg:mb-10">{fields.title}</h2>
            <Content className="max-w-[400px] max-lg:mx-auto max-lg:text-center">{fields.description}</Content>
            <div className="mt-7 lg:mt-11 flex max-lg:justify-center max-lg:mx-auto max-sm:w-full sm:max-w-[271px]">
              <Links
                theme="dark"
                className="flex-col children-a:children-div:w-full children-div:w-full w-full !items-start"
                items={fields.links}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
